import { render, staticRenderFns } from "./DataBox.vue?vue&type=template&id=6be718a1&scoped=true&"
import script from "./DataBox.vue?vue&type=script&lang=js&"
export * from "./DataBox.vue?vue&type=script&lang=js&"
import style0 from "./DataBox.vue?vue&type=style&index=0&id=6be718a1&scoped=true&lang=scss&"
import style1 from "./DataBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be718a1",
  null
  
)

export default component.exports